"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = { postCaptures: false };
exports.requestSlice = (0, toolkit_1.createSlice)({
    name: "request",
    initialState,
    reducers: {
        capture(state, action) {
            state.postCaptures = action.payload.postCaptures;
        },
    },
});
//# sourceMappingURL=requestResource.js.map